module.exports = __webpack_public_path__ + "static/media/AccelAxes.19d27312.gif";